/**
 * Absoulte paths for main app screens.
 */
export enum SCREEN_PATHS {
  DEFAULT = "*",
  CONFIRM_EMAIL = "/verify/:token",
  RESET_PASSWORD = "/reset-password",
  SETUP_PASSWORD = "/setup-password",
  LANDING = "/landing/:senderDataKey/:rtpKey",
  // Two segments: contactKey → /sender-data, payloadKey → /payment-request-decode.
  // Base URL is configured per environment via CONFIG.URLS.REUSABLE_RTP_BASE_URL.
  REUSABLE_RTP_LANDING = "/reusable-rtp/:contactKey/:payloadKey",
  DECLINE_RTP = "/declineRequest/:requestId",
  BANK_SELECT = "/bankselect",
  INITIATE_PAYMENT = "/consent/:bankId",
  PAYMENT_COMPLETE = "/paymentcomplete",
  TERMS_AND_CONDITIONS = "/terms-and-conditions",
  PRIVACY_NOTICE = "/privacy-notice",
  MAVERICK_PAYMENT = "/maverick-payment",
  METRO_PAYMENT = "/metro-payment",
  CARD_PAYMENT = "/card-payment",
}

/**
 * Relative paths for modal views.
 */
export enum MODAL_PATHS {
  THEME = "/theme",
}

const PATHS = {
  SCREEN_PATHS,
  MODAL_PATHS,
};

export default PATHS;
